// exports must end with _{CREATE,UPDATE,DELETE}

// torrents module
export const TORRENTS_ONE_UPDATE = 'TORRENTS_ONE_UPDATE'
export const TORRENTS_ONE_DELETE = 'TORRENTS_ONE_DELETE'
export const TORRENTS_ALL_APPEND = 'TORRENTS_ALL_APPEND'

// lines module
export const LINES_CREATE = 'LINES_CREATE'
export const LINES_FETCHED_CREATE = 'LINES_FETCHED_CREATE'

// notifications module
export const NOTI_STRINGS_UPDATE = 'NOTI_STRINGS_UPDATE'
export const NOTI_STRING_UPDATE = 'NOTI_STRING_UPDATE'
export const NOTI_POSSIBLE_UPDATE = 'NOTI_POSSIBLE_UPDATE'
export const NOTI_SERVICES_UPDATE = 'NOTI_SERVICES_UPDATE'
export const NOTI_SERVICE_CREATE = 'NOTI_SERVICE_CREATE'
export const NOTI_SERVICE_DELETE = 'NOTI_SERVICE_DELETE'
export const NOTI_SERVICE_UPDATE = 'NOTI_SERVICE_UPDATE'
export const NOTI_SERVICE_TESTING_UPDATE = 'NOTI_SERVICE_TESTING_UPDATE'

// status module
export const STATUS_CONNECTED_UPDATE = 'STATUS_CONNECTED_UPDATE'
export const STATUS_SYSTEM_UPDATE = 'STATUS_SYSTEM_UPDATE'
